"use client";

import { useState } from "react";
import { Button, Input, Form } from "react-vant";
import productApi from "@/service/modules/productApi";
import { toast } from "@/components/global/Toast";
import { errorUtils } from "@/utils/error";
import Dialog from "@/components/global/Dialog";

interface Props {
  showWholesale: boolean;
  productID?: string;
  productUrl?: string;
  onClose: () => void;
}
export default function ProductWholesaleDialog({
  productID,
  productUrl,
  showWholesale,
  onClose,
}: Props) {
  const [form] = Form.useForm();

  const [btnLoading, setBtnLoading] = useState(false);

  const onFinish = async (values: Record<string, string>) => {
    setBtnLoading(true);
    const params = {
      ...values,
    };

    if (productUrl) params.productUrl = productUrl;

    try {
      const res = await productApi.wholesale(params);
      const { send } = res.data;
      setBtnLoading(false);
      if (send) {
        toast.show("Success");
        onClose();
      } else {
        toast.show("Error");
      }
    } catch (error: unknown) {
      setBtnLoading(false);
      toast.show(errorUtils.getErrorMessage(error));
    }
  };

  return (
    <Dialog
      visible={showWholesale}
      title=""
      closeable={true}
      showConfirmButton={false}
      showCancelButton={false}
      onCancel={onClose}
    >
      <Form
        form={form}
        onFinish={onFinish}
        layout={"vertical"}
        footer={
          <div>
            <Button
              round
              nativeType="submit"
              type="primary"
              style={{ fontWeight: "700", marginBottom: "14px" }}
              loading={btnLoading}
              loadingText="Contact Us"
              block
            >
              Contact Us
            </Button>
          </div>
        }
      >
        <p
          style={{
            color: "#333333",
            fontSize: "14px",
            lineHeight: "20px",
            paddingBottom: "14px",
            fontWeight: "bold",
          }}
        >
          For orders over 20 pcs or exceeding $2000 (QTY{">"}=5), we&apos;ll
          sort you a top-notch quote. Reach out for more details, cheers!
        </p>

        <Form.Item
          rules={[
            { required: true, message: `Please input your contact email!` },
            { type: "email", message: `Invalid Email Address` },
          ]}
          name="contactEmail"
          label="Your contact email:"
        >
          <Input placeholder="Email address" maxLength={225} />
        </Form.Item>

        <Form.Item
          rules={[{ required: true, message: `Please input your PID number!` }]}
          name="productID"
          label="Items you want to bulk buy:"
          initialValue={productID}
        >
          <Input
            placeholder="Enter the item's link or PID number (the PID No. is above the product title)"
            disabled
          />
        </Form.Item>

        {!productID && (
          <Form.Item
            label="Items you want to bulk buy:"
            name="productInfo"
            rules={[
              {
                required: true,
                message:
                  "Please input the item's link or PID number (the PID No. is above the product title)",
              },
            ]}
          >
            <Input placeholder="Enter the item's link or PID number (the PID No. is above the product title)" />
          </Form.Item>
        )}

        <Form.Item
          label="How many items do you want?"
          name="quantity"
          rules={[{ required: true, message: "Please input your number!" }]}
        >
          <Input
            style={{ width: "100%" }}
            type="digit"
            placeholder="Example:100"
          />
        </Form.Item>
      </Form>
    </Dialog>
  );
}
